import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { Info } from 'lucide-react';

import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card.js';
import { findTimeZoneByValue } from '@/lib/time-zones.js';
import TimezoneIcon from '@/routes/_layout/my-availability/assets/timezone-icon.svg';

interface SessionScheduleCalendarTimezonePillProps {
  timeZone: string;
  dataTestId?: string;
}

/** Coach calendar toolbar timezone — truncates long IANA names; tooltip/hover match shared TooltipPill. */
export function SessionScheduleCalendarTimezonePill({
  timeZone,
  dataTestId,
}: SessionScheduleCalendarTimezonePillProps) {
  const { standardAbbr } = findTimeZoneByValue(timeZone) || {};

  return (
    <div className="group inline-flex max-w-full min-w-0 items-center gap-2 rounded-full bg-gray-100 px-3 py-2 text-gray-700">
      <span className="min-w-0 flex-1 overflow-hidden text-center">
        <div className="flex min-w-0 items-center gap-1 overflow-hidden" data-testid={dataTestId}>
          <img src={TimezoneIcon} alt="Time Zone" className="shrink-0" />
          <span className="truncate text-xs font-medium text-[#404040] md:text-base">
            {timeZone}
            {standardAbbr && `(${standardAbbr})`}
          </span>
        </div>
      </span>
      <HoverCard openDelay={0}>
        <HoverCardTrigger asChild>
          <button
            type="button"
            aria-label="Time zone information"
            className="inline-flex shrink-0 cursor-default rounded-full border-0 bg-transparent p-0"
          >
            <Info className="h-4 w-4 rounded-full transition-colors duration-200 group-hover:bg-gray-600 group-hover:text-white" />
          </button>
        </HoverCardTrigger>
        <HoverCardPrimitive.Portal>
          <HoverCardContent
            side="bottom"
            align="end"
            hideWhenDetached={false}
            collisionPadding={12}
            className="session-schedule-calendar-toolbar-timezone-tooltip z-[102]"
          >
            To change your local time zone, please visit your Account.
          </HoverCardContent>
        </HoverCardPrimitive.Portal>
      </HoverCard>
    </div>
  );
}
